import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ListWrapperStyled = styled(Stack)(({ theme }) => ({
  padding: '0',
  gap: '24px',
  [theme.breakpoints.up('md')]: {
    gap: '32px'
  }
}));
